import { postApi, postCommunicationApi } from "./ventureApi";

export const USER_TYPE_VISITOR = 0;
const SESSION_MS = 60 * 60 * 1000;

// WhatsApp media endpoint expects the production BRS logo URL (same as Angular prod).
export const APP_LOGO_URL = "https://buyrentsale.com/assets/images/logo-2.png";

export const isApiSuccess = (payload) => Number(payload?.status ?? payload?.Status) === 1;

export const readApiBody = (payload) => payload?.body ?? payload?.Body ?? [];

export const readApiError = (payload, fallback) => {
  const message = payload?.errorMessage || payload?.ErrorMessage || payload?.message || payload?.Message;
  return typeof message === "string" && message.trim() ? message : fallback;
};

export const readRequestError = (error, fallback) => {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) {
    return data;
  }
  return readApiError(data, fallback);
};

export const checkUserByMobile = async (mobile) => {
  const response = await postApi("/user/checkbymobile", {
    mobile,
    searchHistory: localStorage.getItem("searchHistory") || ""
  });
  return response.data;
};

export const saveVisitor = async (mobile) => {
  const response = await postApi("/user/addupdatecustomer", {
    UserBasicDetailsID: 0,
    UserID: 0,
    UserName: mobile,
    Password: mobile,
    UserTypeID: USER_TYPE_VISITOR,
    Phone: mobile,
    Mobile: mobile,
    EmailID: ""
  });
  return response.data;
};

export const getUserProfile = async (userId, userType = USER_TYPE_VISITOR) => {
  const response = await postApi(`/user/getuserprofile?UserID=${encodeURIComponent(userId)}&UserType=${encodeURIComponent(userType)}`, null);
  return response.data;
};

const assertSmsDelivered = (payload) => {
  if (payload?.Success === true || payload?.success === true) {
    return payload;
  }

  const detail = payload?.Message || payload?.message || payload?.Response || payload?.response || "SMS delivery failed.";
  throw new Error(typeof detail === "string" ? detail : "SMS delivery failed.");
};

export const sendSms = async (text, number) => {
  // Always use the communication API host (prod via /communication proxy locally).
  const response = await postCommunicationApi("/sendsms", { Text: text, Number: number });
  return assertSmsDelivered(response.data);
};

export const sendWhatsApp = async (mobile, message) => {
  const response = await postCommunicationApi("/whatsappnotificationwithmedia/", {
    number: `91${mobile}`,
    type: "media",
    message,
    media_url: APP_LOGO_URL
  });
  return response.data;
};

export const clearSession = () => {
  localStorage.removeItem("authData");
  localStorage.removeItem("authProfileData");
  localStorage.removeItem("authExpiry");
};

export const hasActiveSession = () => {
  try {
    const raw = localStorage.getItem("authData");
    if (!raw || raw === "undefined" || raw.trim() === "") {
      return false;
    }

    const authData = JSON.parse(raw);
    if (!authData || typeof authData !== "object" || !authData.UserID) {
      return false;
    }

    const expiry = Number(localStorage.getItem("authExpiry"));
    if (expiry && Date.now() > expiry) {
      clearSession();
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

const readableValue = (value) => {
  const formatted = String(value ?? "").trim();
  return formatted && !/^(n\/a|na|null|undefined|-)$/i.test(formatted) ? formatted : "";
};

export const readSessionProfile = () => {
  if (!hasActiveSession()) {
    return null;
  }

  try {
    const authData = JSON.parse(localStorage.getItem("authData") || "null");
    const profile = JSON.parse(localStorage.getItem("authProfileData") || "null");
    const session = {
      ...(authData && typeof authData === "object" ? authData : {}),
      ...(profile && typeof profile === "object" ? profile : {})
    };
    const mobile = readableValue(session.Mobile || session.Phone);
    const namedValue = [session.FullName, session.Name, session.UserName].map(readableValue).find((value) => value && !/^\d+$/.test(value));

    return {
      ...session,
      displayName: namedValue || mobile || "My Profile",
      displayMobile: mobile,
      photoUrl: readableValue(session.UserProfile)
    };
  } catch {
    return null;
  }
};

export const persistSession = (authData, profile) => {
  clearSession();
  localStorage.setItem("authData", JSON.stringify(authData));
  localStorage.setItem("authProfileData", JSON.stringify(profile));
  localStorage.setItem("authExpiry", String(Date.now() + SESSION_MS));
  window.dispatchEvent(new Event("localStorageChange"));
};
